// client/src/components/plataforma/EquipePanel.js
import React from 'react';
import { Users } from 'lucide-react';
import UserRow from './users/UserRow';

const EquipePanel = ({
    users,
    isLoading,
    onOpenActions,
    emptyStateMessage = "Nenhum usuário encontrado."
}) => {
    
    const usersArray = Array.isArray(users) ? users : [];
    
    if (isLoading && usersArray.length === 0) {
        return null; // O loading já é tratado no componente pai
    }

    if (usersArray.length === 0) {
        return (
            <div className="table-empty-state py-12">
                <div className="bg-gray-100 p-4 rounded-full mb-4 inline-flex">
                    <Users className="text-gray-400" size={40} />
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-1">Nenhum usuário encontrado</h3>
                <p className="text-gray-500 max-w-sm">{emptyStateMessage}</p>
            </div>
        );
    }

    // Auto-contido em table-container/table-wrapper — dos 3 consumidores
    // (AccountUsers.js, ContaEquipePage.js, FranquiaUsersPage.js), só o
    // primeiro envolvia isso na mao; os outros dois renderizavam a tabela
    // sem o card branco/sombra que toda outra tabela do app tem.
    return (
        <div className="table-container">
            <div className="table-wrapper">
                <table className="styled-table w-full">
                    <thead>
                        <tr>
                            <th style={{ width: '35%' }}>Nome</th>
                            <th style={{ width: '15%' }}>Função</th>
                            <th style={{ width: '15%' }}>Telefone</th>
                            <th className="text-center" style={{ width: '10%' }}>Status</th>
                            <th className="text-right pr-4" style={{ width: '25%' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usersArray.map((user) => (
                            <UserRow
                                key={user.relationshipId || user._id || user.id || Math.random()}
                                user={user}
                                onOpenActions={onOpenActions}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EquipePanel;